<div class="position-relative">
    <div id="brackets_schedule_title" class="glaeSegmentHeader" [ngClass]="{ 'legacy-styles-section': isCxone }" cvLocalizedText langSection="Games" langKey="Schedule_Component_Title">Schedule Game</div>
    <p id="brackets_schedule_instructions_2" class="mt-1 mb-0 font-size-14" [ngClass]="{ 'legacy-styles-sub-section': isCxone }" cvLocalizedText langSection="Games" langKey="Schedule_Component_Tournament">When would you like to schedule the beginning of the Tournament?</p>

    <p id="brackets_schedule_repeat" class="mb-1 mt-2 font-size-12 font-weight-bold" cvLocalizedText langSection="Games" langKey="Schedule_Component_Repeat">Game Interval</p>
    <div id="brackets_schedule_select" class="mb-3 color-whaleTail font-size-12" cvLocalizedText langSection="Games" langKey="Schedule_Component_Tournament_Select">Select the date for each phase of the tournament.</div>

    <div class="mb-2" *ngFor="let round of rounds; let i = index">
        <div class="d-flex align-items-center">
            <div class="roundName pl-0 font-size-12" cvLocalizedText langSection="Games" [langKey]="round.RoundName"></div>
            <div class="input-group">
                <div class="search-box click-search justify-content-start">
                    <cv-baremetrics-calendar
                        class="d-block daterange daterange--single baremetrics-date-picker"
                        [ngClass]="{'is-invalid': isDateInvalid(i)}"
                        [(currentDate)]="round.StartDate"
                        [earliestDate]="earliestDate"
                        [required]="false"
                        [placeholder]="datePlaceHolder()"
                        [disabled]="isDateInPast(round.StartDate)"
                        (dateChanged)="handleDateChanged(i)">
                    </cv-baremetrics-calendar>
                </div>
            </div>
        </div>

        <p *ngIf="isDateInvalid(i)" class="errorMessage color-redRyder font-size-12 pt-1" cvLocalizedText langSection="Games" langKey="Schedule_Component_Tournament_Error">Select a different date.</p>
    </div>

    <div id="brackets_schedule_warning" class="mb-1 mt-3 color-whaleTail font-size-12" cvLocalizedText langSection="Games" langKey="Schedule_Component_Tournament_Warning">Every phase will start at 12:00 AM on the date selected and go until 11:59 PM of the same day. The payment will happen the day after the final.</div>
</div>
